export default __webpack_public_path__ + "static/media/aequalis7.dfe17241.pdf";